<script setup>

import ScrollPanel from "primevue/scrollpanel";
import {computed, watch} from "vue";
import NeoUiTimeslots from "../ui-components/NeoUiTimeslots.vue";
import NeoUiCalendar from "../ui-components/NeoUiCalendar.vue";
const props = defineProps({
    dateTimeRestrictions: Object,
    theme: Object,
    forms: Object,
    currentBrightness: Number,
    availableTimeslots: Object,
    calendarDates: Object,
    timeslotsLoading: Boolean,
    calendarKey: Number,
})

const form = defineModel('form');
const valid = defineModel('valid');
const selectedDay = defineModel('selectedDay');
const selectedTimeSlot = defineModel('selectedTimeSlot');
const selectedService = defineModel('selectedService');

const containerClasses = computed(() => {
    return {
        'rounded-xl': props.theme.roundness === 1,
        'rounded-2xl': props.theme.roundness === 2,
        'rounded-3xl': props.theme.roundness === 3,
        'bg-transparent border-neutral-700': props.theme.darkMode
    };
})

watch(selectedTimeSlot, (now) => valid.value = !!now)
</script>

<template>
    <div id="date-time" class="px-5 flex flex-col gap-4">
        <p class="font-bold text-xl">
            {{ $t('widget.terms_header') }}
        </p>
        <section class="flex gap-3 max-md:flex-col ">
            <div class="px-0">
                <NeoUiCalendar
                    :key="calendarKey"
                    v-model="selectedDay"
                    :date-time-restrictions="dateTimeRestrictions"
                    :calendar-dates="calendarDates"
                    :theme="theme" :locale="forms.locale"
                    :settings="forms.settings"></NeoUiCalendar>

                <small v-if="form.errors?.day" id="timeslot-error" class="text-red-500">{{form.errors?.day}}</small>
            </div>
            <div class="grow max-md:w-full w-[500px]">
                <ScrollPanel
                    :class="containerClasses"
                    class="grow dark:bg-transparent dark:border-neutral-700 border bg-neutral-50 !h-[408px] transition-opacity duration-300"
                    :style="timeslotsLoading ? 'opacity: 0.4; pointer-events: none' : ''"
                >
                    <NeoUiTimeslots :key="calendarKey" v-model="selectedTimeSlot" :available-time-slots="availableTimeslots" :theme="theme" :selected-date="selectedDay"></NeoUiTimeslots>
                </ScrollPanel>
                <small v-if="form.errors?.timeslot" id="timeslot-error" class="text-red-500">{{form.errors?.timeslot}}</small>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
:root {
    --stepper-steppanel-background: transparent!important;
}
</style>
